import React from 'react'
import {Checkbox, Collapse, List, ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import FolderIcon from "@material-ui/icons/Folder";
import DescriptionIcon from '@material-ui/icons/Description';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    root: {},
    checkbox: {
        padding: "0 11px"
    },
    attachmentIcon: {
        position: "absolute",
        fontSize: "1.3rem"
    },
    attachmentsCount: {
        marginLeft: theme.spacing(2),
        fontWeight: "bold"
    },
    list: {
        marginLeft: theme.spacing(3)
    },
    line: {
        borderBottom: "solid 1px " + theme.palette.border.dark
    },
    italic: {
        fontStyle: 'italic'
    }
}))

const FileTypes = {
    FILE: "FILE",
    PAPER: "PAPER",
    FOLDER: "FOLDER",
    EMPTY: "EMPTY"
}

function EzdrpList(
    {
        documents,
        toggleSelectFile,
        toggleExpandFile,
        selectedFileMap,
        expandedFileMap,
        level = 0
    }) {
    const classes = useStyle();
    const toggleCheckbox = (e, file) => {
        e.stopPropagation();
        if (file.type === FileTypes.FILE)
            toggleSelectFile(file);
    }

    if (documents.length === 0) {
        documents = [{id: "id", name: <span className={classes.italic}>{Tr('no_files_in_directory')}</span>, type: FileTypes.EMPTY, attachments: []}]
    }

    return (
        <List
            className={classes.list}
            component="div"
            dense
        >
            {
                documents.map(x => {
                    const hasExpand = x.type === FileTypes.PAPER || x.type === FileTypes.FOLDER || x.attachments.length > 0;
                    const expanded = expandedFileMap.has(x.id);

                    return (<div key={x.id} >
                        <ListItem disableRipple button onClick={hasExpand ? () => toggleExpandFile(x) : (e) => toggleCheckbox(e, x)}>
                            <ListItemIcon>
                                {x.type === FileTypes.FILE && <Checkbox
                                    className={classes.checkbox}
                                    edge="start"
                                    checked={selectedFileMap.has(x.id)}
                                    tabIndex={-1}
                                    disableRipple
                                    onClick={(e) => toggleCheckbox(e, x)}
                                />}
                                {x.type === FileTypes.FOLDER && <FolderIcon/>}
                                {x.type === FileTypes.PAPER && <DescriptionIcon/>}
                            </ListItemIcon>
                            <ListItemText
                                primary={<>
                                    {x.name}
                                    {hasExpand && <>
                                        <AttachFileIcon className={classes.attachmentIcon}/>
                                        <span className={classes.attachmentsCount}> {'[' + x.attachments.length + ']'}</span>
                                    </>}
                                </>
                                }
                            />
                            {hasExpand ? expanded ? <UnfoldLessIcon/> : <UnfoldMoreIcon/> : null}
                        </ListItem>
                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                            <EzdrpList
                                toggleSelectFile={toggleSelectFile}
                                toggleExpandFile={toggleExpandFile}
                                selectedFileMap={selectedFileMap}
                                expandedFileMap={expandedFileMap}
                                documents={x.attachments}
                                level={level + 1}
                            />
                        </Collapse>
                        {level === 0 && <div className={classes.line}></div>}
                    </div>)
                })}
        </List>)
}

EzdrpList.propTypes = {
    documents: PropTypes.array.isRequired
}

export default EzdrpList;